/* Carte des magasins Market Spas — liste, recherche (Photon), géolocalisation, tri par distance.
   Sans dépendance ; la carte (MapLibre + ms-store-map.js) est chargée à la demande. */
(function (root) {
  'use strict';
  var EARTH_KM = 6371;
  function toRad(d) { return d * Math.PI / 180; }
  function isPoint(p) { return !!p && p.lat !== null && p.lat !== '' && p.lng !== null && p.lng !== '' && Number.isFinite(Number(p.lat)) && Number.isFinite(Number(p.lng)) && Math.abs(Number(p.lat)) <= 90 && Math.abs(Number(p.lng)) <= 180; }
  function haversineKm(a, b) {
    if (!isPoint(a) || !isPoint(b)) return Infinity;
    var dLat = toRad(b.lat - a.lat), dLng = toRad(b.lng - a.lng);
    var s = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(toRad(a.lat)) * Math.cos(toRad(b.lat)) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return 2 * EARTH_KM * Math.asin(Math.sqrt(s));
  }
  function formatKm(km, unit) {
    if (!Number.isFinite(km)) return '';
    var v = km < 10 ? km.toFixed(1).replace('.', ',') : String(Math.round(km));
    return v + ' ' + (unit || 'km');
  }
  function countryOrder(countries, market) {
    var order = (countries || []).slice();
    if (market && order.indexOf(market) > -1) { order.splice(order.indexOf(market), 1); order.unshift(market); }
    return order;
  }
  function sortStores(stores, opts) {
    opts = opts || {};
    var order = countryOrder(opts.countries, opts.market);
    var rank = function (c) { var i = order.indexOf(c); return i === -1 ? 99 : i; };
    return stores.slice().sort(function (a, b) {
      if (opts.origin) {
        var da = haversineKm(opts.origin, a), db = haversineKm(opts.origin, b);
        if (da !== db) return da - db;
      }
      return rank(a.pays) - rank(b.pays) || (Number(a.ordre) || 50) - (Number(b.ordre) || 50) || String(a.nom).localeCompare(String(b.nom), 'fr');
    });
  }
  function nearest(origin, stores, n) { return sortStores(stores.filter(isPoint), { origin: origin }).slice(0, n || 3); }
  function photonUrl(q, opts) {
    opts = opts || {};
    var lang = ['fr', 'de', 'en'].indexOf(opts.lang) > -1 ? opts.lang : 'en';
    var p = new URLSearchParams({ q: q, limit: String(opts.limit || 5), lang: lang, bbox: '-10,35,12,53' });
    if (isPoint(opts.bias)) { p.set('lat', String(opts.bias.lat)); p.set('lon', String(opts.bias.lng)); }
    return 'https://photon.komoot.io/api/?' + p.toString();
  }
  var KIND_RANK = ['postcode', 'city', 'town', 'village', 'municipality', 'suburb', 'hamlet', 'locality', 'administrative', 'county', 'state', 'country'];
  function rankKind(k) { var i = KIND_RANK.indexOf(k); return i === -1 ? KIND_RANK.length : i; }
  function parsePhoton(json) {
    var feats = (json && json.features) || [];
    var out = [];
    feats.forEach(function (f) {
      var p = f.properties || {}, c = (f.geometry || {}).coordinates || [];
      if (!Number.isFinite(c[0]) || !Number.isFinite(c[1])) return;
      var parts = [];
      if (p.name) parts.push(p.name); else if (p.postcode) parts.push(p.postcode);
      if (p.postcode && p.name && p.osm_value !== 'postcode') parts.push(p.postcode);
      var locality = p.city || p.county || p.state;
      if (locality && locality !== p.name) parts.push(locality);
      if (p.countrycode) parts.push(p.countrycode);
      out.push({ label: parts.join(', '), lat: c[1], lng: c[0], kind: p.osm_value || '', key: p.osm_key || '' });
    });
    out.sort(function (a, b) { return rankKind(a.kind) - rankKind(b.kind); });
    return out;
  }
  function debounce(fn, ms) { var t; return function () { var args = arguments, self = this; clearTimeout(t); t = setTimeout(function () { fn.apply(self, args); }, ms); }; }
  function esc(v) { return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function directionsUrl(s, countryName) { return 'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(s.rue + ', ' + s.cp + ' ' + s.ville + ', ' + (countryName || s.pays)); }
  function telHref(t) { return 'tel:' + String(t || '').replace(/[\s.()]/g, ''); }
  function todayIndex() { var d = new Date().getDay(); return d === 0 ? 6 : d - 1; }
  function cardHtml(s, t, km) {
    var by = s.revendeur ? ' <span class="ms-store__by">' + esc(t.by) + ' ' + esc(s.revendeur) + '</span>' : '';
    var name = s.url ? '<a href="' + esc(s.url) + '">' + esc(s.nom) + by + '</a>' : esc(s.nom) + by;
    var dist = Number.isFinite(km) ? '<span class="ms-store__distance" data-ms-distance>' + esc(formatKm(km, t.km)) + '</span>' : '';
    var badges = (s.categorie === 'siege' ? '<span class="ms-store__badge ms-store__badge--hq">' + esc(t.head_office) + '</span>' : '') + (s.rdv ? '<span class="ms-store__badge">' + esc(t.by_appointment) + '</span>' : '');
    var hours = s.horaires && s.horaires.length ? '<details class="ms-store__hours" data-ms-hours><summary>' + esc(t.hours) + '</summary><ul>' + s.horaires.map(function (l) { return '<li>' + esc(String(l).trim()) + '</li>'; }).join('') + '</ul></details>' : '';
    var country = t['country_' + s.pays] || s.pays;
    return '<article class="ms-store" data-ms-store="' + esc(s.handle) + '" data-pays="' + esc(s.pays) + '"' + (isPoint(s) ? ' data-lat="' + s.lat + '" data-lng="' + s.lng + '"' : '') + '><div class="ms-store__body"><h3 class="ms-store__name">' + name + '</h3><p class="ms-store__meta">' + badges + dist + '</p>' + (s.accroche ? '<p class="ms-store__tagline">' + esc(s.accroche) + '</p>' : '') + '<address class="ms-store__address">' + esc(s.rue) + '<br>' + esc(s.cp) + ' ' + esc(s.ville) + '<br>' + esc(country) + '</address>' + hours + '<div class="ms-store__actions"><a class="msl-btn msl-btn--primary" href="' + esc(directionsUrl(s, country)) + '" target="_blank" rel="noopener">' + esc(t.directions) + '</a>' + (s.tel ? '<a class="msl-btn" href="' + esc(telHref(s.tel)) + '">' + esc(t.call) + '</a>' : '') + (s.email ? '<a class="msl-btn" href="mailto:' + esc(s.email) + '">' + esc(t.email) + '</a>' : '') + (s.web ? '<a class="msl-btn msl-btn--ghost" href="' + esc(s.web) + '" target="_blank" rel="noopener">' + esc(t.website) + '</a>' : '') + (s.url ? '<a class="msl-btn msl-btn--ghost" href="' + esc(s.url) + '">' + esc(t.see_store) + '</a>' : '') + '</div></div></article>';
  }
  function biasForMarket(code) {
    var c = { BE: { lat: 50.6, lng: 4.7 }, FR: { lat: 47.0, lng: 2.5 }, LU: { lat: 49.7, lng: 6.1 }, ES: { lat: 36.5, lng: -5.4 }, NL: { lat: 51.3, lng: 4.6 }, DE: { lat: 50.5, lng: 6.5 }, CH: { lat: 46.8, lng: 6.5 } };
    return c[code] || c.BE;
  }
  var loading = null;
  function loadScript(src) { return new Promise(function (res, rej) { var s = document.createElement('script'); s.src = src; s.async = true; s.onload = res; s.onerror = function () { rej(new Error('script ' + src)); }; document.head.appendChild(s); }); }
  function loadCss(href) { if (!href || document.querySelector('link[href="' + href + '"]')) return; var l = document.createElement('link'); l.rel = 'stylesheet'; l.href = href; document.head.appendChild(l); }
  function loadMapLibs(cfg) {
    if (loading) return loading;
    loadCss(cfg.maplibreCss);
    loading = (root.maplibregl ? Promise.resolve() : loadScript(cfg.maplibreJs)).then(function () { return root.MSStoreMap ? null : loadScript(cfg.mapAdapter); });
    return loading;
  }
  // Mise en page empilée (mobile) : un appui sur une fiche ramène la carte à l'écran si elle est hors champ ;
  // un appui sur un marqueur ne fait pas défiler la page vers la fiche (la liste n'est plus un cadre défilant).
  function shouldScrollToMap(rect, vh, stacked) { if (!stacked || !rect) return false; return rect.bottom < 120 || rect.top > (vh || 800) - 120; }
  function shouldScrollToCard(stacked, fromCard) { return !stacked && !fromCard; }
  function isStacked() { return !!(root.matchMedia && root.matchMedia('(max-width: 860px)').matches); }
  function init(el) {
    if (!el || el.__msInit) return;
    el.__msInit = true;
    var d = el.dataset, stores, t;
    try {
      stores = JSON.parse(el.querySelector('[data-ms-stores]').textContent);
      t = JSON.parse(el.querySelector('[data-ms-i18n]').textContent);
    } catch (e) { return; }
    stores.forEach(function (s) {
      s.lat = s.lat == null ? null : Number(s.lat);
      s.lng = s.lng == null ? null : Number(s.lng);
      s.horaires = (s.horaires || []).map(function (l) { return String(l).trim(); }).filter(Boolean);
    });
    var cfg = { mode: d.mode || 'full', hub: d.hub || '/pages/nos-magasins', countries: (d.countries || '').split(',').filter(Boolean), market: d.market || '', lang: (d.lang || 'fr').slice(0, 2), style: d.style || 'light', current: d.current || '', limit: Number(d.limit) || 8, defaultImage: d.defaultImage || '', marker: d.marker || '', maplibreJs: d.maplibreJs, maplibreCss: d.maplibreCss, mapAdapter: d.mapAdapter };
    var ui = { list: el.querySelector('[data-ms-list]'), results: el.querySelector('[data-ms-results]'), form: el.querySelector('[data-ms-search]'), input: el.querySelector('input[name="q"]'), sugg: el.querySelector('[data-ms-suggestions]'), locate: el.querySelector('[data-ms-locate]'), status: el.querySelector('[data-ms-status]'), filters: el.querySelector('[data-ms-filters]'), more: el.querySelector('[data-ms-more]'), map: el.querySelector('[data-ms-map]') };
    var state = { origin: null, originLabel: '', country: 'ALL', expanded: false, selected: '', adapter: null, mapLoading: false, suggestions: [] };
    var cards = {}, byHandle = {};
    el.querySelectorAll('.ms-store[data-ms-store]').forEach(function (c) { cards[c.dataset.msStore] = c; });
    stores.forEach(function (s) { byHandle[s.handle] = s; });
    function setStatus(msg) { if (ui.status) ui.status.textContent = msg || ''; }
    function visibleStores() { return stores.filter(function (s) { return state.country === 'ALL' || s.pays === state.country; }); }
    function sorted() { return sortStores(visibleStores(), { countries: cfg.countries, market: cfg.market, origin: state.origin }); }
    function markToday() {
      el.querySelectorAll('[data-ms-hours] li').forEach(function (li) { li.classList.remove('is-today'); });
      el.querySelectorAll('[data-ms-hours]').forEach(function (det) { var lis = det.querySelectorAll('li'); if (lis.length === 7) lis[todayIndex()].classList.add('is-today'); });
    }
    function renderList() {
      if (!ui.list || cfg.mode === 'compact') return;
      var list = sorted(), n = 0;
      var nearestHandle = state.origin && list.length && isPoint(list[0]) ? list[0].handle : '';
      list.forEach(function (s) {
        var c = cards[s.handle];
        if (!c) return;
        n += 1;
        var km = state.origin ? haversineKm(state.origin, s) : NaN;
        var dEl = c.querySelector('[data-ms-distance]');
        if (dEl) { if (Number.isFinite(km)) { dEl.textContent = formatKm(km, t.km); dEl.hidden = false; } else { dEl.textContent = ''; dEl.hidden = true; } }
        c.classList.toggle('is-nearest', s.handle === nearestHandle);
        c.setAttribute('data-nearest-label', t.nearest || '');
        c.hidden = cfg.mode === 'full' && !state.expanded && n > cfg.limit;
        ui.list.insertBefore(c, ui.more || null);
      });
      Object.keys(cards).forEach(function (h) { if (!byHandle[h] || (state.country !== 'ALL' && byHandle[h].pays !== state.country)) cards[h].hidden = true; });
      if (ui.more) ui.more.hidden = !(cfg.mode === 'full' && !state.expanded && list.length > cfg.limit);
      markToday();
    }
    function renderStoreMode() {
      var cur = byHandle[cfg.current];
      if (!cur) { renderList(); return; }
      var near = nearest(cur, stores.filter(function (s) { return s.handle !== cfg.current; }), 3);
      Object.keys(cards).forEach(function (h) { cards[h].hidden = true; });
      near.forEach(function (s) {
        var c = cards[s.handle];
        if (!c) return;
        c.hidden = false;
        var dEl = c.querySelector('[data-ms-distance]');
        if (dEl) { dEl.textContent = formatKm(haversineKm(cur, s), t.km); dEl.hidden = false; }
        ui.list.insertBefore(c, ui.more || null);
      });
      markToday();
    }
    function renderCompact(list) {
      if (!ui.results) return;
      ui.results.innerHTML = list.map(function (s) { return cardHtml(s, t, state.origin ? haversineKm(state.origin, s) : NaN); }).join('');
      markToday();
    }
    function select(handle, opts) {
      opts = opts || {};
      state.selected = handle;
      Object.keys(cards).forEach(function (h) { cards[h].classList.toggle('is-active', h === handle); });
      var c = cards[handle];
      if (c && c.hidden && cfg.mode === 'full') { state.expanded = true; renderList(); }
      var stacked = isStacked();
      if (c && shouldScrollToCard(stacked, !!opts.fromCard)) c.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      if (opts.fromCard && ui.map && shouldScrollToMap(ui.map.getBoundingClientRect(), root.innerHeight, stacked)) ui.map.scrollIntoView({ block: 'start', behavior: 'smooth' });
      if (state.adapter && !opts.fromMap) state.adapter.select(handle);
      if (cfg.mode !== 'compact' && root.history && root.history.replaceState) { try { root.history.replaceState(null, '', '#magasin=' + handle); } catch (e) { /* navigateur restrictif */ } }
    }
    function setOrigin(pos, label) {
      state.origin = isPoint(pos) ? { lat: Number(pos.lat), lng: Number(pos.lng) } : null;
      state.originLabel = label || '';
      state.expanded = false;
      if (cfg.mode === 'compact') renderCompact(state.origin ? nearest(state.origin, visibleStores(), 3) : []); else renderList();
      if (state.origin) setStatus(label ? t.results_for + ' ' + label : t.near_you);
      if (state.adapter && state.origin) {
        state.adapter.setUser(state.origin, label || t.your_position);
        state.adapter.fitTo([state.origin].concat(nearest(state.origin, visibleStores(), 3)));
      }
    }
    function applyFilter(code) {
      state.country = code;
      state.expanded = false;
      if (ui.filters) ui.filters.querySelectorAll('[data-ms-country]').forEach(function (b) { var on = b.dataset.msCountry === code; b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      renderList();
      if (state.adapter) state.adapter.setVisible(visibleStores().map(function (s) { return s.handle; }));
    }
    function geocode(q) {
      return fetch(photonUrl(q, { lang: cfg.lang, bias: state.origin || biasForMarket(cfg.market) })).then(function (r) { if (!r.ok) throw new Error('photon ' + r.status); return r.json(); }).then(parsePhoton);
    }
    function showSuggestions(list) {
      state.suggestions = list;
      if (!ui.sugg) return;
      ui.sugg.innerHTML = list.map(function (s, i) { return '<li role="option"><button type="button" data-ms-pick="' + i + '">' + esc(s.label) + '</button></li>'; }).join('');
      ui.sugg.hidden = list.length === 0;
      if (ui.input) ui.input.setAttribute('aria-expanded', list.length ? 'true' : 'false');
    }
    function pick(s) { showSuggestions([]); if (ui.input) ui.input.value = s.label; setOrigin(s, s.label); ensureMap(); }
    function runSearch(q) {
      setStatus(t.searching);
      geocode(q).then(function (list) { if (list.length) pick(list[0]); else setStatus(t.no_result); }).catch(function () { setStatus(t.no_result); });
    }
    var onType = debounce(function () {
      var q = ui.input.value.trim();
      if (q.length < 3) { showSuggestions([]); return; }
      geocode(q).then(showSuggestions).catch(function () { showSuggestions([]); });
    }, 300);
    function submitSearch(ev) {
      if (cfg.mode === 'compact') return;
      ev.preventDefault();
      var q = ui.input ? ui.input.value.trim() : '';
      if (!q) return;
      if (state.suggestions.length) { pick(state.suggestions[0]); return; }
      runSearch(q);
    }
    function locateMe() {
      if (!navigator.geolocation) { setStatus(t.geo_unavailable); return; }
      ui.locate.disabled = true;
      setStatus(t.searching);
      ensureMap();
      navigator.geolocation.getCurrentPosition(function (p) {
        ui.locate.disabled = false;
        if (ui.input) ui.input.value = '';
        setOrigin({ lat: p.coords.latitude, lng: p.coords.longitude }, '');
      }, function (err) {
        ui.locate.disabled = false;
        setStatus(err && err.code === 1 ? t.geo_denied : t.geo_unavailable);
        if (ui.input) ui.input.focus();
      }, { enableHighAccuracy: false, timeout: 10000, maximumAge: 300000 });
    }
    function ensureMap() {
      if (!ui.map || state.adapter || state.mapLoading) return;
      state.mapLoading = true;
      loadMapLibs(cfg).then(function () {
        state.adapter = root.MSStoreMap.create(ui.map, {
          stores: stores.filter(isPoint), style: cfg.style, marker: cfg.marker, defaultImage: cfg.defaultImage, i18n: t, current: cfg.current,
          onSelect: function (h) { select(h, { fromMap: true }); },
          onReady: function () {
            ui.map.classList.add('is-ready');
            if (state.country !== 'ALL') state.adapter.setVisible(visibleStores().map(function (s) { return s.handle; }));
            if (state.origin) { state.adapter.setUser(state.origin, state.originLabel || t.your_position); state.adapter.fitTo([state.origin].concat(nearest(state.origin, visibleStores(), 3))); }
            if (state.selected) state.adapter.select(state.selected);
          }
        });
      }).catch(function () { state.mapLoading = false; });
    }
    if (ui.list) {
      ui.list.addEventListener('click', function (ev) { var c = ev.target.closest('.ms-store'); if (!c || ev.target.closest('a, button, summary, details')) return; select(c.dataset.msStore, { fromCard: true }); ensureMap(); });
      ui.list.addEventListener('mouseover', function (ev) { var c = ev.target.closest('.ms-store'); if (c && state.adapter) state.adapter.highlight(c.dataset.msStore, true); });
      ui.list.addEventListener('mouseout', function (ev) { var c = ev.target.closest('.ms-store'); if (c && state.adapter) state.adapter.highlight(c.dataset.msStore, false); });
    }
    if (ui.form) ui.form.addEventListener('submit', submitSearch);
    if (ui.input) {
      ui.input.addEventListener('input', onType);
      ui.input.addEventListener('focus', ensureMap);
      ui.input.addEventListener('keydown', function (ev) { if (ev.key === 'Escape') showSuggestions([]); });
    }
    if (ui.sugg) ui.sugg.addEventListener('click', function (ev) { var b = ev.target.closest('[data-ms-pick]'); if (b) pick(state.suggestions[Number(b.dataset.msPick)]); });
    document.addEventListener('click', function (ev) { if (ui.sugg && !el.contains(ev.target)) showSuggestions([]); });
    if (ui.locate) ui.locate.addEventListener('click', locateMe);
    if (ui.filters) ui.filters.addEventListener('click', function (ev) { var b = ev.target.closest('[data-ms-country]'); if (b) applyFilter(b.dataset.msCountry); });
    if (ui.more) ui.more.addEventListener('click', function () { state.expanded = true; renderList(); });
    if (cfg.mode === 'store') renderStoreMode(); else renderList();
    var q = new URLSearchParams(root.location.search).get('q');
    if (q && ui.input && cfg.mode !== 'store') { ui.input.value = q; runSearch(q); }
    var hash = /[#&]magasin=([\w-]+)/.exec(root.location.hash || '');
    if (hash && byHandle[hash[1]]) { select(hash[1]); ensureMap(); }
    if (ui.map && 'IntersectionObserver' in root) {
      var io = new IntersectionObserver(function (entries) { if (entries.some(function (e) { return e.isIntersecting; })) { io.disconnect(); ensureMap(); } }, { rootMargin: '600px 0px' });
      io.observe(ui.map);
      root.addEventListener('scroll', function onScroll() { var r = ui.map.getBoundingClientRect(); if (r.top < (root.innerHeight || 800) + 600) { root.removeEventListener('scroll', onScroll); ensureMap(); } }, { passive: true });
    } else if (ui.map) ensureMap();
    el.__msLocator = { select: select, setOrigin: setOrigin, applyFilter: applyFilter, state: state, cfg: cfg };
  }
  function initAll(scope) { (scope || document).querySelectorAll('[data-ms-locator]').forEach(init); }
  root.MSStoreLocator = { haversineKm: haversineKm, isPoint: isPoint, formatKm: formatKm, sortStores: sortStores, nearest: nearest, photonUrl: photonUrl, parsePhoton: parsePhoton, cardHtml: cardHtml, directionsUrl: directionsUrl, todayIndex: todayIndex, shouldScrollToMap: shouldScrollToMap, shouldScrollToCard: shouldScrollToCard, init: init, initAll: initAll };
  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); }); else initAll();
    document.addEventListener('shopify:section:load', function (ev) { initAll(ev.target); });
  }
})(typeof window !== 'undefined' ? window : globalThis);
